<template>
    <MainMenuRow :title="privacyLabel" icon="bi-shield-lock" test-id="nav-privacy" :show-label="showLabel" @click="handleClick" />
    <PrivacyNoticeDialog v-model:open="privacyDialogOpen" />
</template>

<script setup lang="ts">
import type { OrganizationDetails } from "~vue/appTypes";
import PrivacyNoticeDialog from "~vue/Onboarding/PrivacyNoticeDialog.vue";
import AmplitudeEventNames from "~vue/utils/amplitudeEventNames";
import { logUserInteraction } from "~vue/utils/logUtils";
import { computed, inject, type Ref, ref } from "vue";

import MainMenuRow from "./MainMenuRow.vue";
import { privacyRowLabel } from "./menuPanes";

const { showLabel = true } = defineProps<{ showLabel?: boolean }>();

const organizationDetails = inject<Ref<OrganizationDetails | null>>("organization_details");
const privacyLabel = computed(() => privacyRowLabel(organizationDetails?.value?.privacy_link_label));
const privacyDialogOpen = ref(false);

function handleClick() {
    // English, for Amplitude: event properties must not change with the user's language.
    const title = organizationDetails?.value?.privacy_link_label || "Privacy";
    logUserInteraction(AmplitudeEventNames.MAIN_MENU_ITEM_CLICKED, { id: "privacy", title });
    privacyDialogOpen.value = true;
}
</script>
